import React from "react";
import PropTypes from "prop-types";
import { Grid, TextField, Paper, Typography } from "@material-ui/core";
import useSharedStyles from "./SharedStyle";

const CompanyShareholderInfo = ({
  formData,
  handleChange,
  hintFormText,
  disable
}) => {
  const classes = useSharedStyles();

  const renderField = (field) => (
    <>
      <Typography className={classes.label}>
        {field.label}
        {field.required && <span className={classes.requiredAsterisk}>*</span>}
      </Typography>
      <TextField
        variant="outlined"
        fullWidth
        size="small"
        id={field.name}
        name={field.name}
        type={field.type || "text"}
        value={formData[field.name] || ""}
        onChange={handleChange}
        placeholder={hintFormText?.[field.name] || field.placeholder}
        required={field.required}
        inputProps={field.inputProps}
        autoComplete="off"
        disabled={disable}
      />
    </>
  );

  const fields = [
    {
      name: "companyName",
      label: "Company Name",
      placeholder: "Enter the name of the company",
      required: true,
    },
    {
      name: "shareholderName",
      label: "Shareholder Name",
      placeholder: "Enter the name of the shareholder",
      required: true,
    },
    {
      name: "claimantName",
      label: "Claimant Name",
      placeholder: "Enter the name of the claimant",
      required: true,
    },
    {
      name: "beneficiaryAccount",
      label: "Beneficiary Account No.",
      placeholder: "Enter the beneficiary account number",
      required: true,
    },
    {
      name: "securityType",
      label: "Type of Security",
      placeholder: "Enter the type of security",
      required: true,
    },
    { name: "folioId", label: "Folio ID", placeholder: "Enter the folio ID" },
    { name: "dematId", label: "Demat ID", placeholder: "Enter the demat ID" },
    {
      name: "SRN",
      label: "SRN",
      placeholder: "Enter the SRN (Service Request Number)",
    },
  ];

  return (
    <Paper className={classes.paper} elevation={2}>
      <Typography variant="h6" className={classes.sectionTitle}>
        Company and Shareholder Information
      </Typography>
      <Grid container spacing={2} padding={2}>
        {fields.map((field) => (
          <Grid item xs={12} md={4} key={field.name}>
            {renderField(field)}
          </Grid>
        ))}
        <Grid item xs={12} md={4}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              {renderField({
                name: "numberOfShares",
                label: "Number of Shares",
                type: "text",
                placeholder: "Enter the number of shares",
                required: true,
                inputProps: { min: "0", step: "1" },
              })}
            </Grid>
            <Grid item xs={6}>
              {renderField({
                name: "shareFaceValue",
                label: "Face Value (Rs.)",
                type: "text",
                placeholder: "Enter the face value of shares",
                required: true,
                inputProps: { min: "0", step: "0.01" },
              })}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

CompanyShareholderInfo.propTypes = {
  formData: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  hintFormText: PropTypes.object,
  disable: PropTypes.bool,
};

export default CompanyShareholderInfo;
